<template lang="html">

	<footer class="footer" :withoutPadLogin="withoutPadLogin">

		<div class="footer-container row-between" :withoutMT="withoutMT">

			<div class="top row-center">
				<template v-for="t in texts" v-if="!!texts">
					<p v-html="t"></p>
				</template>
			</div>

			<nav class="bottom row-center" v-if="!!links">

				<template v-for="(data, key) in links">

					<a :href="data" target="_blank">{{key}}</a>

				</template>

				
			</nav>

		</div>

	</footer>

</template>

<script lang="js">
	
	import {mapGetters} from 'vuex';

	export default  {
		name: 'app-footer',
		computed : {
			...mapGetters({
				colors : 'basicColors',
				texts : 'getFooterText',
				links : 'getFooterLinks',
				version : 'getVersion',
				
			}),
			ownstyles : function(){
				return {
					bgWhite : {
						background : this.colors.white
					}
				}
			},
			withoutMT : function(){
				let views = [
				'/login/empresas',
				'/login/antiguos',
				'/login/alumnos',
				'/login/estudiantes',
				'/mantenimiento',
				'/acceso',
				'/gma2019',
				];
				return (views.some(el => el == this.$route.path));
			},
			withoutPadLogin : function(){
				let views = [
				'/login/empresas',
				'/login/antiguos',
				'/login/alumnos',
				'/login/estudiantes',
				];
				return (views.some(el => el == this.$route.path));
			}
		}
	}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/parts/footer.vue